<zah-therapeuten [initialPageRequest]="initialPageRequest"
                 [therapeutenPage]="therapeutenPage$ | async"
                 (therapeutClicked)="navigateToTherapeut($event)"
                 (deleteClicked)="deleteTherapeut($event)"
                 (addClicked)="navigateToAddTherapeut()"
                 (pageChange)="onPageChange($event)">
</zah-therapeuten>
